import { render, staticRenderFns } from "./RevisarChapuzon2026.vue?vue&type=template&id=eba85c14&scoped=true&"
import script from "./RevisarChapuzon2026.vue?vue&type=script&lang=ts&"
export * from "./RevisarChapuzon2026.vue?vue&type=script&lang=ts&"
import style0 from "./RevisarChapuzon2026.vue?vue&type=style&index=0&id=eba85c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba85c14",
  null
  
)

export default component.exports